import { styled } from '@mui/material/styles';
import { Box, IconButton, Checkbox } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import CloseIcon from '@mui/icons-material/Close';

export const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    width: '48%'
  }
}));

export const SelectWrapper = styled(Box)({
  position: 'relative',
  width: '100%',
  minWidth: 134
});

export const SelectTrigger = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 14px',
  border: '1px solid #c4c4c4',
  borderRadius: 8,
  backgroundColor: '#fff',
  cursor: 'pointer',
  minHeight: 42,
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease'
});

export const TriggerContent = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flex: 1,
  overflow: 'hidden',
  fontSize: 14
});

export const SelectedCount = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 14,
  color: '#333'
});

export const CountBadge = styled('span')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#061923',
  color: '#fff',
  borderRadius: '50%',
  padding: 0,
  fontSize: 10,
  fontWeight: 500,
  minWidth: 18,
  minHeight: 18
});

export const ArrowIcon = styled(KeyboardArrowDownIcon, {
  shouldForwardProp: prop => prop !== 'isOpen'
})(({ isOpen }) => ({
  color: '#757575',
  transition: 'transform 0.2s ease',
  fontSize: 20,
  ...(isOpen && {
    transform: 'rotate(180deg)'
  })
}));

export const Dropdown = styled(Box, {
  shouldForwardProp: prop => prop !== 'alignRight'
})(({ theme, alignRight }) => ({
  position: 'absolute',
  top: 'calc(100% + 4px)',
  left: alignRight ? 'auto' : 0,
  right: alignRight ? 0 : 'auto',
  width: 240,
  maxWidth: 240,
  backgroundColor: '#fff',
  borderRadius: 8,
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
  zIndex: 1300,
  maxHeight: 320,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    width: 280,
    minWidth: 280,
    maxWidth: 280
  }
}));

export const SearchContainer = styled(Box)({
  padding: 12,
  borderBottom: '1px solid #e0e0e0'
});

export const SearchInputWrapper = styled(Box)({
  position: 'relative',
  display: 'flex',
  alignItems: 'center'
});

export const StyledSearchIcon = styled(SearchIcon)({
  position: 'absolute',
  left: 10,
  color: '#9e9e9e',
  fontSize: 18,
  pointerEvents: 'none'
});

export const SearchInput = styled('input')({
  width: '100%',
  padding: '10px 12px',
  paddingLeft: 36,
  paddingRight: 36,
  border: '1px solid #e0e0e0',
  borderRadius: 6,
  fontSize: 14,
  outline: 'none',
  transition: 'border-color 0.2s ease',
  '&:focus': {
    borderColor: '#061923',
    borderWidth: 2
  },
  '&::placeholder': {
    color: '#9e9e9e'
  }
});

export const ClearButton = styled(IconButton)({
  position: 'absolute',
  right: 4,
  padding: 4
});

export const ClearIcon = styled(CloseIcon)({
  color: '#9e9e9e'
});

export const LoadingText = styled(Box)({
  padding: 16,
  textAlign: 'center',
  color: '#9e9e9e',
  fontSize: 14
});

export const OptionsList = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  padding: '8px 0',
  '&::-webkit-scrollbar': {
    width: 6
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: '#f5f5f5'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#bdbdbd',
    borderRadius: 3
  }
});

export const OptionItem = styled(Box, {
  shouldForwardProp: prop => prop !== 'isSelected'
})(({ isSelected }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '10px 16px 10px 10px',
  cursor: 'pointer',
  transition: 'background-color 0.15s ease',
  '&:hover': {
    backgroundColor: '#f5f5f5'
  },
  ...(isSelected && {
    fontWeight: 800
  })
}));

export const OptionLabel = styled('span')({
  fontSize: 14,
  color: '#333',
  flex: 1
});

export const NoOptions = styled(Box)({
  padding: '16px',
  textAlign: 'center',
  color: '#9e9e9e',
  fontSize: 14
});

export const TableCheckbox = styled(Checkbox)(() => ({
  padding: 0
}));
